import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./translations/en.json";
import nl from "./translations/nl.json";
import de from "./translations/de.json";
import pl from "./translations/pl.json";

const resources = {
  en: { translation: en },
  nl: { translation: nl },
  de: { translation: de },
  pl: { translation: pl },
};

const getInitialLanguage = () => {
  try {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      return storedLanguage;
    }
  } catch (error) {
    // Ignore localStorage access issues.
  }
  return "en";
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (language) => {
  try {
    localStorage.setItem("language", language);
  } catch (error) {
    // Ignore localStorage access issues.
  }
});
